// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

// 引入重置样式
import '@/assets/public/css/reset.css';
// 引入公共基础样式
import '@/assets/public/css/common.css';

// 引入字体
import '@/assets/fontFamily/font.css';

// SVG
import '@/assets/icons';

import DataV from '@jiaminghi/data-view'

Vue.use(DataV);

// 引入自定义指令
import directive from './directive';

Vue.use(directive);

// 引入公共方法
import utils from '@/utils/pub-utils.js';

Vue.prototype.$utils = utils;

// vuex为了开发大型项目，主要是(状态)管理，将数据统一管理
import store from './store';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.use(Antd);
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Element)

import messageToast from '@/utils/messageToast'

Vue.prototype.$messageToast = messageToast;

//引入echarts
import * as echarts from 'echarts';//在import的后面，echarts的前面加一个 * as
//vue全局注入echarts
Vue.prototype.$echarts = echarts;

// 分页组件
import Pagination from "@/components/Pagination";

Vue.component('Pagination', Pagination)

// 引入
import {codemirror} from "vue-codemirror";
// 引入配置对应的文件（样式、主题、代码格式等）
import "@/utils/cm-setting.js";
// 注册使用
Vue.component("codemirror", codemirror);

// 引入全屏组件
import fullscreen from 'vue-fullscreen';

Vue.use(fullscreen);

// 引入vue-video-player
import VideoPlayer from 'vue-video-player';

require('vue-video-player/src/custom-theme.css');
require('video.js/dist/video-js.css');
import 'videojs-contrib-hls';

// 使用vue-video-player
Vue.use(VideoPlayer);

// 二维码
import QRCode from 'qrcode';

Vue.use(QRCode);

// 引入clipboard
import clipboard from '@/utils/clipboard';

Vue.prototype.$clipboard = clipboard;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,// store被注册到实例上 所有组件都会有一个属性：this.$store
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js